import type { Id, IIdentifier } from "@/models"

const findById = <T extends IIdentifier>(items: T[], id: Id): T | undefined => items.find((item) => item.id === id)

export default findById
